import { ApiResult, request, safeRequest } from '@synergy/api';

import { CategoryDto } from '../models/dto/category-dto';

export class CategoriesApi {
    constructor(protected baseUrl: string) {}

    public getCategories = (parentId?: number): Promise<ApiResult<CategoryDto[]>> => {
        const rootOnly = parentId === undefined;
        return safeRequest(
            () => request.get(`${this.baseUrl}/all-categories`, { params: { parentId, rootOnly } }),
            response => response.data
        );
    };
}
